// Module
var code = "<div class=\"fc-nps-item__value\" data-bind=\"text: value\"></div>\n";
// Exports
module.exports = code;